import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
export default function Cta() {
  const location = useLocation();

  return (
    <section className="cta-section about_page_cta_sec">
      <div className="container">
        <h2 className="blur-glow global-body-heading-fonts">
          Let's Build Your High-Converting Shopify Experience
        </h2>
        <div className="cta-buttons">
          <HashLink
            smooth
            // to="/#booking"
            to={`${location.pathname}#booking`}
            className="btn-white blur-vanish-left"
          >
            Book Free Strategy Session
          </HashLink>
          <Link to="/contact" className="btn-outline blur-vanish-right">
            Send Us a Message
          </Link>
        </div>
      </div>
    </section>
  );
}
